module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/user-content.79e9d19d..png" + "?" + Date.now();